import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/routing/ScrollToTop';
import LegacyRedirect from './components/routing/LegacyRedirect';
import { seoLandingPages } from './content/seoLandingPages';
import { LEGACY_REDIRECTS, FLEET_SAAS_HUB } from './content/seoUrlManifest';
import HomePage from './pages/HomePage';
import SiteLoader from './components/loading/SiteLoader';

const LogisticsPage = lazy(() => import('./pages/LogisticsPage'));
const FleetPage = lazy(() => import('./pages/FleetPage'));
const CareersPage = lazy(() => import('./pages/CareersPage'));
const ContactUsPage = lazy(() => import('./pages/ContactUsPage'));
const SeoLandingPage = lazy(() => import('./pages/SeoLandingPage'));
const ComparePage = lazy(() => import('./pages/ComparePage'));
const LegalDocumentPage = lazy(() => import('./pages/LegalDocumentPage'));
const StaticHtmlLegalPage = lazy(() => import('./pages/StaticHtmlLegalPage'));

function PageFallback() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <SiteLoader />
    </div>
  );
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<PageFallback />}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/logistics" element={<LogisticsPage />} />
          <Route path={FLEET_SAAS_HUB} element={<FleetPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/compare/logistics-vs-fleet-saas" element={<ComparePage />} />
          {seoLandingPages.map((page) => (
            <Route key={page.path} path={page.path} element={<SeoLandingPage pagePath={page.path} />} />
          ))}
          {Object.entries(LEGACY_REDIRECTS).map(([from, to]) => (
            <Route key={from} path={from} element={<LegacyRedirect to={to} />} />
          ))}
          <Route path="/privacy-policy" element={<LegalDocumentPage />} />
          <Route path="/terms-condition" element={<LegalDocumentPage />} />
          <Route path="/fleet-privacy-policy" element={<LegalDocumentPage />} />
          <Route path="/distributor-privacy-policy" element={<LegalDocumentPage />} />
          <Route path="/retailers-privacy-policy" element={<LegalDocumentPage />} />
          <Route path="/rider-privacy-policy" element={<LegalDocumentPage />} />
          <Route path="/chakradhar_privacy_policy.html" element={<StaticHtmlLegalPage />} />
          <Route path="/pavan_distributor_privacy_policy.html" element={<StaticHtmlLegalPage />} />
          <Route path="/zeromeds_privacy_policy.html" element={<StaticHtmlLegalPage />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
